import { useMemo } from 'react';
import type { PartialUtmParameters } from '@shared/utils/utmParameters';
import { resolveAcquisitionAwareUtm, useUtmParameters } from '@shared/utils/utmParameters';

/**
 * Hook form of {@link resolveAcquisitionAwareUtm}. Prefer this over `useMergedUtmParameters` for any
 * hotel / accommodations CTA: those are reached from internally-stamped URLs, where "the current URL
 * wins" means "the upstream Joy page wins" and the CTA loses its own attribution.
 * Use it for the outgoing URL *and* the click's telemetry payload so the two can't drift.
 */
export const useAcquisitionAwareUtm = (internalUtm: PartialUtmParameters): PartialUtmParameters => {
  const currentUtm = useUtmParameters();

  // Destructured to primitives so a fresh object literal from the caller doesn't bust the memo.
  const { utm_medium, utm_source, utm_campaign, utm_source_secondary } = internalUtm;

  return useMemo(
    () => resolveAcquisitionAwareUtm(currentUtm, { utm_medium, utm_source, utm_campaign, utm_source_secondary }),
    [currentUtm, utm_medium, utm_source, utm_campaign, utm_source_secondary],
  );
};
